import qs from 'query-string';
import Constants from './Constants';
const QueryString = {
    getCurrent() {
        return qs.parse(location.search);
    },
    setCurrentUrl(value) {
        const newQueryString = qs.stringify(value);
        window.history.pushState(null, '', `?${newQueryString}`);
        return newQueryString;
    },
    stringify(value) {
        return qs.stringify(value);
    },
    stringifyToPath(path, value) {
        return `${Constants.webUrl}/${path}?${qs.stringify(value)}`;
    },
    stringifyToUrl(url, value) {
        return `${url}?${qs.stringify(value)}`;
    }
};
export default QueryString;
